import "components/jiffy/flash-message/flash-message";
import "./flash-messages.scss";

const SELECTORS = {
  CLOSE_BTN_WRAPPER: ".js-flash-message-close-wrapper",
  FLASH_MESSAGES: ".js-flash-messages",
  FLASH_MESSAGE: ".js-flash-message"
};

class FlashMessages {
  #$cachedCloseBtnsWrapper;

  #$cachedFlashMessages;

  get #$closeBtnsWrapper() {
    this.#$cachedCloseBtnsWrapper ??= [...document.querySelectorAll(SELECTORS.CLOSE_BTN_WRAPPER)];
    return this.#$cachedCloseBtnsWrapper;
  }

  get #$flashMessages() {
    this.#$cachedFlashMessages ??= document.querySelector(SELECTORS.FLASH_MESSAGES);
    return this.#$cachedFlashMessages;
  }

  #removeCachedCloseBtnWrapper($btnWrapper) {
    this.#$cachedCloseBtnsWrapper = this.#$cachedCloseBtnsWrapper.filter(
      $cachedBtnWrapper => $cachedBtnWrapper !== $btnWrapper
    );
  }

  #removeFlashMessages() {
    this.#$flashMessages?.remove();
    this.#$cachedFlashMessages = null;
  }

  handleCloseBtnWrapperClick($closeBtnWrapper) {
    $closeBtnWrapper.closest(SELECTORS.FLASH_MESSAGE)?.remove();
    this.#removeCachedCloseBtnWrapper($closeBtnWrapper);
    if (this.#$cachedCloseBtnsWrapper.length === 0) {
      this.#removeFlashMessages();
    }
  }

  initCloseBtnClickHandlers() {
    this.#$closeBtnsWrapper.forEach($closeBtnWrapper => {
      $closeBtnWrapper.addEventListener(
        "click",
        this.handleCloseBtnWrapperClick.bind(this, $closeBtnWrapper)
      );
    });
  }

  init() {
    this.initCloseBtnClickHandlers();
  }
}

const flashMessages = new FlashMessages();

document.addEventListener("DOMContentLoaded", () => {
  flashMessages.init();
});

export default FlashMessages;
